<div class="modal-report-operational-discipline">
    <img
        appImageSelector
        alt="mt-image"
        imageType="icon"
        imageKey="close-gray"
        class="close-modal"
        (click)="activeModal.dismiss()"
    />
    <div class="d-flex justify-content-center">
        <span class="title">
            {{ "production-details" | lang }} - {{ machineName }} -
            {{ params.startDate | datePresentation }} - {{ "shift_" | lang }}
            {{ shiftName }}</span
        >
    </div>

    <app-main-table [tableConfig]="tableConfig"></app-main-table>
</div>
